import colorLevel from './colorLevel';
import contrastingColor from './contrastingColor';
import readableColor from './readableColor';

const util = {
  colorLevel,
  contrastingColor,
  readableColor,
};

export default util;
